import React from 'react';
import PropTypes from 'prop-types';
import './main.less';
import Button from './button/main';

class Buttons extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return (
			<div className="main-menu__controls">
				{this.props.children}
			</div>);
	}
}
Buttons.propTypes = {
	children: PropTypes.element
};
Buttons.Button = Button;

export { Button };
export default Buttons;




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/sidebar/components/buttons/main.js